export default `
scalar DateTime

interface Node {
  id: ID!
}

interface Payload {
  clientMutationId: String!
}

type User implements Node{
  id: ID!
  name: String
  property: String
  notifications: [Notification]
}

interface PicklistInterface {
  id: ID!
  name: String!
  region: String
  marketerEmails: String
  approvalRequired: Boolean
  userRole: String
  hyblastSetting: HyblastSetting!
}

type Org implements PicklistInterface & Node {
  createdAt: DateTime!
  id: ID!
  name: String!
  region: String
  marketerEmails: String
  approvalRequired: Boolean
  suborgs(name: String): [Suborg!]!
  userRole: String
  hyblastSetting: HyblastSetting!
}

type Suborg implements PicklistInterface & Node {
  createdAt: DateTime!
  id: ID!
  name: String!
  org: Org!
  region: String
  marketerEmails: String
  approvalRequired: Boolean
  userRole: String
  hyblastSetting: HyblastSetting!
}

type HyblastSetting implements Node {
  agentApprovalEmails: [String!]!
  approvalRequired: Boolean!
  approverEmails: [String!]!
  emailLimits: [EmailLimit!]!
  id: ID!
}

type EmailLimit implements Node {
  groupType: String!
  id: ID!
  monthlyMax: Int!
  monthlyMin: Int!
  weeklyMax: Int!
  weeklyMin: Int!
}

type Notification implements Node {
  id: ID!
  createdAt: String
  header: String
  body: String
  status: String
  sourceType: String
  sourceId: String
}

type NotificationsContainer implements Node {
  id: ID!
  notifications: [Notification]!
}

type Template implements Node {
  createdAt: DateTime!
  id: ID!
  largeThumbnailUrl: String
  name: String!
  smallThumbnailUrl: String
}

type FloorPlan implements Node {
  areaMax: String
  areaMin: String
  createdAt: DateTime!
  id: ID!
  imageDimension: String!
  imageName: String!
  imageSize: Int!
  imageUrl: String!
  name: String!
  thumbnailUrl: String
}

type Category implements Node {
  assets(name: String): [Asset!]!
  createdAt: DateTime!
  hasMore: Boolean!
  id: ID!
  name: String!
  templates(name: String): [Template!]!
  floorPlans(name: String): [FloorPlan!]!
  type: String!
}

type Query {
  user(id: ID!): User
  authorizedOrgs(name: String, first: Int=50): [Org!]!
  authorizedSuborgs(orgId: ID!, propertyId: String, name: String, first: Int=50): [Suborg!]!
  notifications(id: ID!, scope: String): NotificationsContainer!
  categories(
    propertyId: ID!
    type: String = "template"
  ): [Category!]!
}

input NotificationDeleteInput {
  id: ID!
  scope: String
  clientMutationId: String!
}

type PageInfo {
  endCursor: String
  hasNextPage: Boolean!
  hasPreviousPage: Boolean!
  startCursor: String
}

type AssetConnection {
  edges: [AssetEdge]
  nodes: [Asset]
  pageInfo: PageInfo!
}

type AssetEdge {
  cursor: String!
  node: Asset
}

type Asset implements Node {
  createdAt: DateTime!
  fileSize: String!
  fileType: String!
  fileUrl: String!
  id: ID!
  name: String!
  thumbnailUrl: String
}

input uploadAssetInput {
  clientMutationId: String
  propertyId: ID!
  categoryId: ID!
  name: String!
  imageData: String!
}

type uploadAssetPayload {
  asset: Asset
  assetEdge: AssetEdge
  assetsConnection: AssetConnection
  clientMutationId: String
}

type Mutation {
  notificationDelete(input: NotificationDeleteInput!): Payload
  uploadAsset(input: uploadAssetInput!): uploadAssetPayload
}

schema {
  query: Query
  mutation: Mutation
}
`;
